import {fetchExtraProductInfo} from "../../data-layer/src/fetch-extra-product-info";
import {getProductsList, getProductsTotal} from "./tmr-products";
import {BRAND_NAME} from "../../data-layer/src/meta";


export function tmrCostumeViewAddCart(products) {
    return Promise.resolve({
            type: 'itemView',
            productid: getProductsList(products),
            pagetype: 'cart',
            list: '1',
            totalvalue: getProductsTotal(products),
        }
    );
}
